var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title is-5" }, [_vm._v("Datos del usuario")]),
    _vm._v(" "),
    _c("div", { staticClass: "field is-horizontal" }, [
      _c("div", { staticClass: "field-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Nombre")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.nombre,
                  expression: "model.nombre",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{ required: true }",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.errors.has("nombre del usuario") },
              attrs: {
                name: "nombre del usuario",
                "data-vv-scope": "userData",
              },
              domProps: { value: _vm.model.nombre },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "nombre", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.has("nombre del usuario")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("nombre del usuario"))),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Apellido")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.apellido,
                  expression: "model.apellido",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{ required: true }",
                },
              ],
              staticClass: "input",
              class: { "is-danger": _vm.errors.has("apellido del usuario") },
              attrs: {
                name: "apellido del usuario",
                "data-vv-scope": "userData",
              },
              domProps: { value: _vm.model.apellido },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "apellido", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.has("apellido del usuario")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("apellido del usuario"))),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("CUIL")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control" },
            [
              _c("the-mask", {
                staticClass: "input",
                class: { "is-danger": _vm.errors.has("cuil") },
                attrs: { mask: "##-########-#", type: "text", masked: false },
                model: {
                  value: _vm.model.cuil,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "cuil", $$v)
                  },
                  expression: "model.cuil",
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model.cuil,
                    expression: "model.cuil",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{ required: true }",
                  },
                ],
                staticClass: "input",
                class: { "is-danger": _vm.errors.has("cuil") },
                attrs: {
                  type: "hidden",
                  name: "cuil",
                  "data-vv-scope": "userData",
                },
                domProps: { value: _vm.model.cuil },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.model, "cuil", $event.target.value)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.has("cuil")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("cuil"))),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-5" }, [_vm._v("Datos de acceso")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "field is-horizontal" }, [
      _c("div", { staticClass: "field-body" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Email de acceso")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.email,
                  expression: "model.email",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true, email: true },
                  expression: "{ required: true, email: true }",
                },
              ],
              staticClass: "input is-mono",
              class: { "is-danger": _vm.errors.has("email usuario") },
              attrs: {
                type: "email",
                name: "email usuario",
                placeholder: "Ej: jgimenez@email.com",
                "data-vv-scope": "userData",
              },
              domProps: { value: _vm.model.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "email", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.has("nombre del usuario")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("nombre del usuario"))),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [
            _vm._v("Usuario  "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.$store.getters.hasAnyRole([
                        "lyris",
                        _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                      ]) && _vm.edit,
                    expression:
                      "!$store.getters.hasAnyRole(['lyris', constants.STRINGS.ROLES.LYRIS_SOPORTE.ID]) && edit",
                  },
                ],
                staticClass: "tag is-success is-rounded",
              },
              [_vm._v("Lyris")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.acceso,
                  expression: "model.acceso",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{ required: true }",
                },
              ],
              staticClass: "input is-mono",
              class: { "is-danger": _vm.errors.has("nombre del usuario") },
              attrs: {
                name: "nombre del usuario",
                "data-vv-scope": "userData",
                placeholder: "Ej: jgimenez",
                disabled:
                  !_vm.$store.getters.hasAnyRole([
                    "lyris",
                    _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                  ]) && _vm.edit,
              },
              domProps: { value: _vm.model.acceso },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.model, "acceso", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.errors.has("nombre del usuario")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("nombre del usuario"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.$store.getters.hasAnyRole([
                      "lyris",
                      _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                    ]) && _vm.edit,
                  expression:
                    "!$store.getters.hasAnyRole(['lyris', constants.STRINGS.ROLES.LYRIS_SOPORTE.ID]) && edit",
                },
              ],
              staticClass: "help",
            },
            [
              _c("i", { staticClass: "fas fa-exclamation-triangle" }),
              _vm._v(" Solamente Lyris puede cambiar este campo\n        "),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    !_vm.edit
      ? _c("div", [
          _c("br"),
          _vm._v(" "),
          _c("h1", { staticClass: "title is-5" }, [_vm._v("Clave de acceso")]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field is-expanded" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Contraseña")]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.model.clave,
                        expression: "model.clave",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: false, min: 6 },
                        expression: "{ required: false, min: 6 }",
                      },
                    ],
                    ref: "password",
                    staticClass: "input",
                    attrs: {
                      placeholder: "Contraseña",
                      name: "password",
                      type: "password",
                      "data-vv-name": "password",
                      "data-vv-scope": "userData",
                    },
                    domProps: { value: _vm.model.clave },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.model, "clave", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("password"),
                          expression: "errors.has('password')",
                        },
                      ],
                      staticClass: "help is-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("password")))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field is-expanded" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Repetir contraseña"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.repeatPassword,
                        expression: "repeatPassword",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: _vm.rulesPassword,
                        expression: "rulesPassword",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      placeholder: "Re-escriba la password",
                      type: "password",
                      "data-vv-name": "password_confirmation",
                      "data-vv-as": "contraseña",
                      "data-vv-scope": "userData",
                    },
                    domProps: { value: _vm.repeatPassword },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.repeatPassword = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("password_confirmation"),
                          expression: "errors.has('password_confirmation')",
                        },
                      ],
                      staticClass: "help is-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("password_confirmation")))]
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "buttons is-right" }, [
      _c(
        "button",
        {
          staticClass: "button is-primary",
          attrs: { disabled: _vm.errors.any() },
          on: {
            click: function ($event) {
              return _vm.submit()
            },
          },
        },
        [_vm._v("\n        Guardar\n      ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v("Defina los datos de acceso a la plataforma")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _c("i", { staticClass: "fas fa-info-circle" }),
        _vm._v(
          " Tenga en cuenta: Si no ingresa contraseña, se le generará al usuario una clave y se le notifica por email la misma. En el caso de ingresar una contraseña, el email no será enviado."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }